var map = {
	"./basic.vue": "Lmk5",
	"./default.vue": "JR3i"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XNwU";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/layouts nonrecursive .*\.vue$
// module id = XNwU
// module chunks = 15